/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { isEmpty } from 'lodash'

import {
  Picklist
} from '../'

const initialiseOptions = (employers, defaultOption) => {
  let employersValueIdMapping = {}
  if (defaultOption) {
    employersValueIdMapping[defaultOption] = ''
  }

  let employersIdValuePairs = employers.map(({ node: employer }) => (
    {
      id: employer.id,
      value: employer.firstName
    }
  ))

  employersIdValuePairs.forEach(employer => (
    employersValueIdMapping[employer.value] = employer.id
  ))

  return { options: employersValueIdMapping }
}

class EmployerPicklist extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    default: PropTypes.string,
    value: PropTypes.string,
    closeDropdownOnSelect: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    minWidth: PropTypes.number,
    maxHeight: PropTypes.number,
    symbol: PropTypes.string,
    inline: PropTypes.bool,
    className: PropTypes.string
  }

  static defaultProps = {
    symbol: 'chevrondown',
    inline: false
  }

  static getDerivedStateFromProps(props, state) {
    if (isEmpty(state.options) && props.data.identities) {
      return initialiseOptions(props.data.identities.edges, props.default)
    } else {
      return null
    }
  }

  state = {
    options: {}
  }

  render() {
    if (this.props.data.loading) {
      return (
        <Picklist
          id={this.props.id}
          options={[]}
          placeholder='Loading'
          minWidth={this.props.minWidth}
          disabled={true}
          symbol='threedots'
          onChange={() => false}
        />
      )
    }

    if (this.props.data.error) {
      return (
        <Picklist
          id={this.props.id}
          options={[]}
          placeholder='Failed to load options'
          minWidth={this.props.minWidth}
          disabled={true}
          symbol='warning'
          onChange={() => false}
        />
      )
    }

    let employers = this.state.options
    return (
      <Picklist
        id={this.props.id}
        default={this.props.default}
        options={Object.keys(employers)}
        symbol={this.props.symbol}
        value={this.props.value === ''
           ? this.props.default
           : Object.keys(employers).find(key => employers[key] === this.props.value)
        }
        onChange={(value) => (
          this.props.onChange(value === ''
            ? value
            : this.state.options[value]
          )
        )}
        closeDropdownOnSelect={this.props.closeDropdownOnSelect}
        inline={this.props.inline}
        minWidth={this.props.minWidth}
        maxHeight={this.props.maxHeight}
        className={this.props.className}
      />
    )
  }
}

const getEmployers = gql`
  query {
    identities(employer_Id_Isnull: false, orderBy: "first_name"){
      edges {
        node {
          id
          firstName
        }
      }
    }
  }
`

export const withData = graphql(getEmployers)

export default withData(EmployerPicklist)



// WEBPACK FOOTER //
// ./src/components/employer-picklist/index.js